
export default {
  approved: 'approved',
  unapproved: 'unapproved',
  pending: 'pending'
}